/*
Commonly-used constants.
*/

export const MIN_SESSION_SECS = 10;
export const MIN_SESSION_BYTES = 1024;
